import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResetPasswordModel, ResetPasswordViewModel } from '@hrra/common-models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { resetPassword, clearResetPasswordPageInfo } from 'src/app/root-store/jobseeker-store/reset-password/actions';
import { selectIsResetSuccessed, selectPasswordResetViewModel, selectUserRegistrationNotFound } from 'src/app/root-store/jobseeker-store/reset-password/selectors';
import { selectRecaptchaSiteKey } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-jobseeker-password-reset',
    templateUrl: './jobseeker-password-reset.component.html',
    styleUrls: ['./jobseeker-password-reset.component.scss'],
    standalone: false
})
export class JobseekerPasswordResetComponent implements OnInit {
  
  submitForm: UntypedFormGroup;

  userRegistrationNotFound$: Observable<boolean>;
  isResetSuccessed$: Observable<boolean>;
  recaptchaSiteKey$: Observable<string>;
  resetPasswordModel$: Observable<ResetPasswordViewModel>;

  constructor(private store: Store<AppState>, private router: Router) { 
    this.submitForm = new UntypedFormGroup({
      email: new UntypedFormControl(null,  Validators.required),
      recaptcha: new UntypedFormControl(null, Validators.required)
    });
  }

  ngOnInit(): void {
    this.store.dispatch(clearResetPasswordPageInfo());

    this.userRegistrationNotFound$ = this.store.pipe(select(selectUserRegistrationNotFound));
    this.isResetSuccessed$ = this.store.pipe(select(selectIsResetSuccessed));
    this.recaptchaSiteKey$ = this.store.pipe(select(selectRecaptchaSiteKey));
    this.resetPasswordModel$ = this.store.pipe(select(selectPasswordResetViewModel));
    }

  resetPassword(){
    if (this.submitForm.valid){

      let request = <ResetPasswordModel>{
        email: this.submitForm.get('email').value,
        reCaptchaToken: this.submitForm.get('recaptcha').value,
      }
  
      this.store.dispatch(resetPassword({payload: request}));
    }
  }

  public submitResetPasswordForm(formDirective: FormGroupDirective) {
    if (this.submitForm.valid){
      formDirective.resetForm();
      this.submitForm.reset();
    }
  }
}
